<!--
 * @Author: M.D.
 * @Date: 2019-12-29 10:24:43
 * @LastEditors  : M.D.
 * @Description: isSel为是选中状态, val对应外部值
 * @Remarks:
 -->
<template>
  <div class="inner-l-if-w">
    <ul>
      <li
        @click="activeIdxChg(i)"
        v-for="i in filterArr"
        :key="i.key"
        :class="{ active: i.isSel === 1 }"
      >
        {{ i.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    filterArr: {
      type: Array,
      default: () => [
        {
          name: '综合',
          key: 1,
          isSel: 1,
        },
        {
          name: '最新',
          key: 2,
          isSel: 0,
        },
        {
          name: '价格从低到高',
          key: 3,
          isSel: 0,
        },
        {
          name: '价格从高到低',
          key: 4,
          isSel: 0,
        },
      ],
    },
  },
  data() {
    return {
      curIdx: 1, // 从1开始
    }
  },
  computed: {},
  created() {
    this.$emit('fVal', this._.cloneDeep(this.filterArr))
  },
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    activeIdxChg(i) {
      if (this._.find(this.filterArr, { isSel: 1 }).key === i.key) return
      this.filterArr.forEach((item) => {
        item.isSel = 0
      })
      i.isSel = 1
      this.$emit('fVal', this._.cloneDeep(this.filterArr))
    },
  },
  components: {},
}
</script>

<style lang="stylus">
.inner-l-if-w {
  height: 60px;
  line-height: 60px;
  padding: 0 40px;
  color: #999999;
  font-size: 20px;
  ul {
    li {
      display: inline-block;
      padding: 0 14px;
      text-align: center;
      margin-right: 10px;

      &:hover {
        cursor: pointer;
        color: theme-color;
      }

      &.active {
        color: theme-color;
        border-bottom: 2px solid theme-color;
      }
    }
  }
}
</style>
